<div class="row back-ground-color">
  <div class="col-2 col-md-2 col-sm-2 col-xs-2 search-bar mt-2" id="searchBar">
    <div class="parameterOption">
      <input class="form-control fixed-height-search regularText" type="text" (keyup)="globalService.applyFilter($event.target.value, pipelineList)" placeholder="Search">
      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
    </div>
  </div>
  <div class="col-8 col-sm-8 col-md-8 col-lg-8 mt-2">
    <mat-chip-listbox #chipList>
      <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
        {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
        <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
  <div class="col-2 col-sm-2 col-md-2 co-lg-2 regularText">
    <div class="ml-2 addBtn exportIcon iconSize imgAddScenario display-block textRightExport alignRight MarginRight20" (click)="exporterPipeline.exportTable('xlsx', {fileName:'Pipeline', sheet: 'PipelineList'})">&nbsp;</div>
    <div class="addBtn filterIcon iconSize imgAddScenario display-block textRightExport alignRight" placement="bottom-right" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth">&nbsp;</div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 text-center" *ngIf="isLoader==true">
    <div class="loader"></div>
  </div>
</div>
<div class="d-flex table-container">
  <div class="col-12 fixed-height">
    <mat-table #pipelineTable #pipelineTableSort="matSort" matSort matTableExporter [dataSource]="pipelineList" matSortActive="name​​"
               matSortDirection="asc" #exporterPipeline="matTableExporter" hiddenColumns="[3]">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2"> Pipeline Name </mat-header-cell>
        <mat-cell *matCellDef="let element" class="regularText"> {{element.name}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">Pipeline Description</mat-header-cell>
        <mat-cell *matCellDef="let element" class="regularText"> {{element.description}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="folderName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">Folder Name</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.folderName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef class="TitleMatAction heading2">Action</mat-header-cell>
        <mat-cell *matCellDef="let row" class="TitleMatAction">
          <span>
            <a class="pointer pl-15" (click)="redirectToADF()" title="View"><mat-icon>visibility</mat-icon></a>
          </span>
        </mat-cell>        
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #pipelinePaginator [pageSizeOptions]="[10,20,30]" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>
</div>
<ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
